import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { SelectProductForm } from '../../../forms/forms/select-product.form';
import { getProductCategoryLink } from '../../../shared/constants/links.constants';
import { ProductWithBarcode } from '../../../shared/models/product-with-barcode.model';
import { BarcodesApi } from '../../api/barcodes/barcodes-api.service';
import { ProductsApi } from '../../api/products/products-api.service';

@Component({
  selector: 'app-product-search-dialog',
  templateUrl: './product-search-dialog.component.html',
  styleUrl: './product-search-dialog.component.scss',
})
export class ProductSearchDialogComponent {
  form = new SelectProductForm(this.barcodesApi, this.productsApi);
  product?: ProductWithBarcode;

  constructor(
    private matDialogRef: MatDialogRef<ProductSearchDialogComponent>,
    private barcodesApi: BarcodesApi,
    private productsApi: ProductsApi,
    private router: Router
  ) {}

  setProduct(product: ProductWithBarcode | undefined): void {
    this.product = product;
  }

  openProductCategory(product: ProductWithBarcode): void {
    const productCategoryLink = getProductCategoryLink(product.productCategoryId);

    this.matDialogRef.close();
    this.matDialogRef.afterClosed().subscribe(() => {
      this.router.navigate([productCategoryLink], { fragment: 'products' });
    });
  }
}
